import { FC, useEffect, useReducer, useRef } from 'react';

import formatRelative from 'date-fns/formatRelative';

import { MINUTE } from '@hsp/utilities';

const NotificationTime: FC<{ createdAt: number }> = ({ createdAt }) => {
  const [, forceUpdate] = useReducer((update) => update + 1, 0);
  const intervalRef = useRef<NodeJS.Timeout>();

  useEffect(() => {
    intervalRef.current = setInterval(() => {
      forceUpdate();
    }, MINUTE);

    return () => {
      clearInterval(intervalRef.current);
    };
  }, []);

  return <span className="font-size-10 mt-auto text-muted">{formatRelative(new Date(createdAt), new Date())}</span>;
};

export default NotificationTime;
